window.hubo = window.hubo || {};

export enum WindowKeys {
    TRACKER = 'tracker',
}

export default class WindowManagement {
    static saveObject = (key: WindowKeys, value: any) => {
        window.hubo[key] = value;
    };

    static getObject = (key: WindowKeys) => {
        return window.hubo[key];
    };
}
